import { schema } from 'normalizr';
import { SCHEMA_TYPE_AUDIT_LOG } from '../constants/schemaTypes';

import userSchema from './user';

const auditLogSchema = new schema.Entity(SCHEMA_TYPE_AUDIT_LOG);

auditLogSchema.define({
  impersonator: userSchema,
  owner: userSchema,
  user: userSchema,
});

export default auditLogSchema;
